export const TOOLTIPS = {
  hardCost: `Hard costs include any expenditures related to physical construction. These costs may include materials, sitework, foundation, vertical construction, labor, overhead, and any fees paid to the general contractor or developer. 

    Enter figure in millions of dollars. `,
  duration: 'Make your selection based on the duration of the physical construction period. The duration should exclude any non-construction activities, such as planning, acquisition, design, administrative, or operating phases.',
  architecture: `Architecture and engineering costs include fees paid to architects or engineers. Consulting and legal fees can also be included in these costs.

  Enter figure in millions of dollars.
  `,
  furniture: `Furniture, fixtures and equipment (FF&E) costs include the purchase of any components not permanently attached to the project’s structure. These costs may include decorative items, beds, desks, chairs, ovens, refrigerators, shelving, televisions, and computers. Large commercial machinery can also be included in these costs.  

  Enter figure in millions of dollars.
  `,
  revenue: `Gross revenue during year 2 of operations. No deductions from top line revenue are required. 

  Enter figure in millions of dollars. 
  `
}